import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import PropTypes from 'prop-types';
import { BaseControl } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
/**
 * This component is essentially a wrapper (really a reimplementation) around the
 * TextControl component that adds support for affixes, i.e. the ability to display
 * a fixed part either at the beginning or at the end of the text input.
 */

var TextControlWithAffixes =
/*#__PURE__*/
function (_Component) {
  _inherits(TextControlWithAffixes, _Component);

  function TextControlWithAffixes() {
    _classCallCheck(this, TextControlWithAffixes);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextControlWithAffixes).apply(this, arguments));
  }

  _createClass(TextControlWithAffixes, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          value = _this$props.value,
          help = _this$props.help,
          className = _this$props.className,
          instanceId = _this$props.instanceId,
          onChange = _this$props.onChange,
          prefix = _this$props.prefix,
          suffix = _this$props.suffix,
          type = _this$props.type,
          props = _objectWithoutProperties(_this$props, ["label", "value", "help", "className", "instanceId", "onChange", "prefix", "suffix", "type"]);

      var id = "inspector-text-control-with-affixes-".concat(instanceId);

      var onChangeValue = function onChangeValue(event) {
        return onChange(event.target.value);
      };

      var describedby = [];

      if (help) {
        describedby.push("".concat(id, "__help"));
      }

      if (prefix) {
        describedby.push("".concat(id, "__prefix"));
      }

      if (suffix) {
        describedby.push("".concat(id, "__suffix"));
      }

      return createElement(BaseControl, {
        label: label,
        id: id,
        help: help,
        className: className
      }, createElement("div", {
        className: "text-control-with-affixes"
      }, prefix && createElement("span", {
        id: "".concat(id, "__prefix"),
        className: "text-control-with-affixes__prefix"
      }, prefix), createElement("input", _extends({
        className: "components-text-control__input",
        type: type,
        id: id,
        value: value,
        onChange: onChangeValue,
        "aria-describedby": describedby.join(' ')
      }, props)), suffix && createElement("span", {
        id: "".concat(id, "__suffix"),
        className: "text-control-with-affixes__suffix"
      }, suffix)));
    }
  }]);

  return TextControlWithAffixes;
}(Component);

TextControlWithAffixes.defaultProps = {
  type: 'text'
};
TextControlWithAffixes.propTypes = {
  /**
   * If this property is added, a label will be generated using label property as the content.
   */
  label: PropTypes.string,

  /**
   * If this property is added, a help text will be generated using help property as the content.
   */
  help: PropTypes.string,

  /**
   * Type of the input element to render. Defaults to "text".
   */
  type: PropTypes.string,

  /**
   * The current value of the input.
   */
  value: PropTypes.string.isRequired,

  /**
   * The class that will be added with "components-base-control" to the classes of the wrapper div.
   * If no className is passed only components-base-control is used.
   */
  className: PropTypes.string,

  /**
   * A function that receives the value of the input.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Markup to be inserted at the beginning of the input.
   */
  prefix: PropTypes.node,

  /**
   * Markup to be appended at the end of the input.
   */
  suffix: PropTypes.node
};
export default withInstanceId(TextControlWithAffixes);
//# sourceMappingURL=index.js.map